'use strict';

class AccountLogo {
  constructor($location, originatorService, Notification) {
    this.$location = $location;
    this.originatorService = originatorService;
    this.Notification = Notification;
  }

  $onInit() {
    this.file = {
      filename: null,
      size: 0,
      base64: null,
      contentType: null
    };
  }

  upload() {
    if (this.file.size >= 65535) {
      this.Notification.error('Logoen kan ikke være større enn 64 KB');
    } else if (this.file.contentType !== 'image/png' && this.file.contentType !== 'image/gif' && this.file.contentType !== 'image/jpg' && this.file.contentType !== 'image/jpeg') {
      this.Notification.error('Filen må være en bildefil, dvs si at man ikke kan laste opp for eksempel en .pdf fil');
    } else {
      this.originatorService.uploadLogo(
        {
          contentType: this.file.contentType,
          logo: this.file.base64
        })
        .then(() => this.$location.path('/konto'))
        .catch((err) => this.Notification.error(err.data.endUserMessage));
    }
  }
}

AccountLogo.$inject = ['$location', 'originatorService', 'Notification'];

const accountLogo = {
  controller: AccountLogo,
  template: `
    <h2>Opplasting av logo</h2>

    <p>Her kan du laste opp en logo som vil bli skrevet ut på fakturaen.</p>
    <p>Ved utskrift vil logoen bli <b>3,53 x 3,53 cm</b>, logoen skrives ut i farger. For best mulig resultat, last opp en logo som er kvadratisk.</p>
    <p>Det er to regler ved opplasting av en logo:
      <ul style="list-style-position: inside;">
        <li>Logoen kan ikke være større enn <b>64 KB</b></li>
        <li>Filen må være en bildefil, det vil si at man ikke kan laste opp for eksempel en <em>.pdf</em> fil</li>
      </ul>
    </p>

    <form name="uploadForm">
      <fieldset>
        <h3 class="subheader">Last opp ny logo</h3>

        <input type="file" id="logo" name="logo" ng-model="$ctrl.file" accept="image/*" maxsize="64" input-base-sixty-four>
      </fieldset>

      <button ng-disabled="uploadForm.$invalid" class="button" ng-click="$ctrl.upload()">Lagre</button>
      <a role="button" class="button secondary" href="#/konto">Avbryt</a>
    </form>
  `
};

angular
  .module('SendRegning')
  .component('accountLogo', accountLogo)
  .config(($routeProvider) => {
    $routeProvider
      .when('/konto/logo', {
        title: 'Logo',
        template: '<account-logo/>',
        secure: true
      });
  });
